import React from 'react'
import { NavLink } from 'react-router-dom';
import Slider from 'react-slick'

const HeroSection = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    fade: true,
    speed: 2000,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
  };

  return (
    <>
      <section className='hero_section position-relative'>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-2 order-md-1">
              <div className="hero_content">
                <span className='sub_heading'>Get set to the target</span>
                <h1 className='my-3'>Website Design and Digital Marketing Company</h1>
                <p>We are talented individuals who want to make a difference, people who like to go the extra mile to ensure quality. If you are searching for a team rather than a company, you have certainly hit the right target!</p>
                <div className='mt-5'>
                  <NavLink className="text-decoration-none drona-btn btn" to="/contact-us">Start working with us</NavLink>
                </div>
              </div>
            </div>
                      <div className="col-md-6 hero_slide position-relative order-1 order-md-2">
                          
              <Slider {...settings}>
                <div>
                    <img src="./images/website-1.webp" className='website-slide' alt="Banner" />
                </div>
                <div>
                  <img src="./images/website-2.webp" className='website-slide' alt="Banner" />
                </div>
                <div>
                  <img src="./images/website-3.webp" className='website-slide' alt="Banner" />
                </div>
                <div>
                  <img src="./images/website-4.webp" className='website-slide' alt="Banner" />
                </div>
                <div>
                  <img src="./images/website-5.webp" className='website-slide' alt="Banner" />
                </div>
              </Slider>
            </div>
          </div>
        </div>
        <div className="lines">
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
          <div className="line"></div>
        </div>
      {/* <div className="spider-hero">
      <canvas id="scratch" style={{ width: '400px', height: '400px' }} title="Move A Dot With Mouse" width="400" height="400"></canvas>
      </div> */}
      </section>
    </>
  )
}

export default HeroSection